/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * API
 * OpenAPI spec version: 1.0.0
 */

export type GetApiDoctorsPortalDoctors200DoctorsItemStatus =
    (typeof GetApiDoctorsPortalDoctors200DoctorsItemStatus)[keyof typeof GetApiDoctorsPortalDoctors200DoctorsItemStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiDoctorsPortalDoctors200DoctorsItemStatus = {
    INVITED: 'INVITED',
    LINKED: 'LINKED',
    REJECTED: 'REJECTED',
    SELF_UNLINKED: 'SELF_UNLINKED',
    REMOVED: 'REMOVED',
} as const;
